import {
    Button, CardContent, FormControl, FormControlLabel, FormGroup, Switch, TextField,
    FormLabel, RadioGroup, Radio, FormHelperText, Checkbox
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import api from '../../../services/api';
import { ANAO, ASIM } from 'consts';
import PropTypes from 'prop-types';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import ComboPadrao from 'views/Components/ComboPadrao';
import Box from '@material-ui/core/Box';
import { ATIPO_INTERNO, ATIPO_EXTERNO } from '../../../consts';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import { Info as InfoIcon } from '@material-ui/icons';
import { validate } from 'validate.js';
import { formatDateForInput, validateField } from 'lib/functions';

class AbastecimentoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            abastecimento: {},
            errors: {},
            codcombustivel: [],
            descveiculo: [],
            tipoabastecimento: ATIPO_EXTERNO, //Inicializa com o valor atual
            bombas: [],
            veiculos: [],
            classes: [],
            combustiveis: [],
            isNewRecord: false,
            isView: false,
            schema: {
                data: {
                    presence: { allowEmpty: false, message: 'Data obrigatória!' },
                    length: { maximum: 10 },
                    type: 'date'
                },
                codveiculo: {
                    presence: { allowEmpty: false, message: 'Veículo obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                horimetro_km: {
                    presence: { allowEmpty: false, message: 'Hodômetro inválido!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                qtdlitros: {
                    presence: { allowEmpty: false, message: 'Quantidade de litros obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                precoporlitro: {
                    presence: { allowEmpty: true, message: 'Valor litro obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },

                nrotanque: {
                    presence: { allowEmpty: false, message: 'Número Tanque obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },


                valor: {
                    presence: { allowEmpty: true, message: 'Valor total obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                codcombustivel: {
                    presence: { allowEmpty: false, message: 'Combustível obrigatório!' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                codbomba: {
                    presence: { allowEmpty: false, message: 'Bomba interna obrigatória!' },
                    length: { maximum: 100 },
                    type: 'integer'
                }
            },

            useStyles: makeStyles(theme => ({
                root: {
                    backgroundColor: theme.palette.background.default,
                    height: '100%'
                },
                grid: {
                    height: '100%'
                },
                quoteContainer: {
                    [theme.breakpoints.down('md')]: {
                        display: 'none'
                    }
                },
                quote: {
                    backgroundColor: theme.palette.neutral,
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundImage: 'url(/images/auth.jpg)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                },
                quoteInner: {
                    textAlign: 'center',
                    flexBasis: '600px'
                },
                quoteText: {
                    color: theme.palette.white,
                    fontWeight: 300
                },
                name: {
                    marginTop: theme.spacing(3),
                    color: theme.palette.white
                },
                bio: {
                    color: theme.palette.white
                },
                contentContainer: {},
                content: {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                },
                contentHeader: {
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: theme.spacing(5),
                    paddingBototm: theme.spacing(2),
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2)
                },
                logoImage: {
                    marginLeft: theme.spacing(4)
                },
                contentBody: {
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'center',
                    [theme.breakpoints.down('md')]: {
                        justifyContent: 'center'
                    }
                },
                form: {
                    paddingLeft: 100,
                    paddingRight: 100,
                    paddingBottom: 125,
                    flexBasis: 700,
                    [theme.breakpoints.down('sm')]: {
                        paddingLeft: theme.spacing(2),
                        paddingRight: theme.spacing(2)
                    }
                },
                title: {
                    marginTop: theme.spacing(3)
                },
                socialButtons: {
                    marginTop: theme.spacing(3)
                },
                socialIcon: {
                    marginRight: theme.spacing(1)
                },
                sugestion: {
                    marginTop: theme.spacing(2)
                },
                textField: {
                    marginTop: theme.spacing(2)
                },
                signInButton: {
                    margin: theme.spacing(2, 0)
                },
                alert: {
                    color: '#FF0000',
                }
            }))
        }
    }

    async componentDidMount() {
        // carrega informações formulário
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;

        if (id >= 0) {
            const response = await api.get(`/abastecimento/${id}`);

            response.data[0].data = formatDateForInput(response.data[0].data);

            this.setState({
                abastecimento: response.data[0],
                isNewRecord: false,
                isView: (currentPath.includes('/view'))
            }
            );

            const veiculos = await api.get(`/veiculo/listforchange/${response.data[0].codveiculo}`);
            this.setState({ veiculos: veiculos.data });

            const combustiveis = await api.get(`/combustivel/listforchange/${response.data[0].codcombustivel}`);
            this.setState({ combustiveis: combustiveis.data });

            const bombas = await api.get(`/bomba/listforchange/${response.data[0].codbomba}`);
            this.setState({ bombas: bombas.data });
        }

        else if (id === 'novo') {
            this.setState({
                isNewRecord: true
            });
            this.state.isNewRecord = true;

            const configuracoes = await api.get(`/configuracoes/1`);
            //console.log(JSON.stringify( 'configuracoes: ' + configuracoes.data));
            //console.log('configuracoes:', configuracoes.data[0]);
            this.setState({ configuracoes: configuracoes.data[0] });


            let paramsveiculo = `?page=1&limit=500`;
            const veiculos = await api.get(`/veiculo/active/true${paramsveiculo}`);
            //console.log(JSON.stringify('os veiculos..:' + veiculos.data));
            this.setState({ veiculos: veiculos.data });

            const categoriascombustivel = await api.get(`/categoriacombustivel/active/true`);
            this.setState({ categoriascombustivel: categoriascombustivel.data });

            const combustiveis = await api.get(`/combustivel/active/true`);
            this.setState({ combustiveis: combustiveis.data });

            //   const projetos = await api.get(`/financas/projeto/active/true`);
            //  this.setState({ projetos: projetos.data });

            //  const postos = await api.get(`/fornecedor/active/true${paramsposto}`);
            //  this.setState({ postos: postos.data });

            //const motoristas = await api.get(`/fornecedor/active/true${paramsmotorista}`);
            //this.setState({ motoristas: motoristas.data });

            //console.log('vai carregar bombas..');
            const bombas = await api.get(`/bomba/active/true`);
            
            const { abastecimento } = this.state;
           
            //console.log('total de bombas..:' + bombas.data.length)
            if (bombas.data.length == 1){
                //console.log('vai atribuir bombas.coddomba:' + JSON.stringify(bombas.data[0].codbomba));
                abastecimento.codbomba = bombas.data[0].codbomba;
            }
            this.setState({ bombas: bombas.data });


            abastecimento.tipoabastecimento = ATIPO_INTERNO;
            this.setState({ abastecimento: abastecimento });

        }
    }

    /* evento on change componentes */
    OnChange = (event) => {
        const { abastecimento } = this.state;
        const input = event.target;
        const cursorPosition = input.selectionStart;
        const { name, type, value, checked } = event.target;

        let adjustedValue = value;

        // Atualiza o campo digitado
        abastecimento[name] = value;
        this.setState({ abastecimento });

        //console.log('escolhendo field..:' + name)
        // Verifica se 'volume' e 'valor total' estão preenchidos para calcular 'preço por litro'
        if (name == "qtdlitros" || name == "valor") {
            const volume = parseFloat(abastecimento.qtdlitros);
            const valorTotal = parseFloat(abastecimento.valor);

            if (volume > 0 && valorTotal > 0) {
                abastecimento.precoporlitro = (valorTotal / volume).toFixed(2);
            } else {
                abastecimento.precoporlitro = 0;
            }
        } else if (name == "precoporlitro") {
            const qtdlitros = parseFloat(abastecimento.qtdlitros);
            const precoporlitro = parseFloat(abastecimento.precoporlitro);
            const valorTotal = (qtdlitros * precoporlitro);
            abastecimento.valor = valorTotal;

        }




        switch (type) {
            case 'radio':
                adjustedValue = Number(value);
                break;
            case 'checkbox':
                if (name === 'inativo') {
                    if (checked === false) {
                        adjustedValue = ASIM;
                    }
                    else {
                        adjustedValue = ANAO;
                    }
                }

                if (name === 'solicitadopelocliente') {
                    if (checked === false) {
                        adjustedValue = ANAO;
                    } else {
                        adjustedValue = ASIM;
                    }
                }

                break;
            default:
                if ((name == 'precoporlitro') || (name === 'valor')) {
                    adjustedValue = Number(value.replace(/\./g, '').replace(',', '.'));
                }
                else if (name === 'codveiculo') {
                    const veiculoSelecionado = this.state.veiculos.find(
                        v => v.codveiculo === parseInt(value)
                    );
                    if (veiculoSelecionado) {
                        abastecimento['codcombustivel'] = veiculoSelecionado.codcombustivel;
                    }
                }
                else if ((name === 'nrotanque') && (this.state.isNewRecord)) {
                    let qtdlitro = (adjustedValue - this.state.configuracoes.ultimonrotanque);
                    if (qtdlitro > 0) {
                        abastecimento['qtdlitros'] = qtdlitro;
                    }

                }

        }

        // Atualiza o estado com o valor ajustado
        abastecimento[name] = adjustedValue;
        this.setState({ abastecimento: abastecimento }, () => {
            if (input.type === "text") {
                input.setSelectionRange(cursorPosition, cursorPosition);
            }
        });
    };

    /* atualiza dados de abastecimento existente - post */
    atualizaAbastecimento = async () => {
        const { abastecimento } = this.state;
        try {
            const response = await api.put(`/abastecimento/${abastecimento.codabastecimento}`, abastecimento);
            if (response.status === 200) {
                this.props.history.push('/front/abastecimento');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* Click salvar */
    onClickSave = () => {
        let errors = {};
        //console.log('vai realizar a validação...');
        errors = this.validationRequiredFields();
        //console.log('o que está em errors: ' + JSON.stringify(errors))
        //console.log('passou a validação...');
        this.setState({ errors });
        if (Object.keys(errors).length === 0) {
            if (this.state.isNewRecord) {
                this.insereAbastecimento()
            }
            else {
                this.atualizaAbastecimento();
            }
        }
    }

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/front/abastecimento');
    }

    /* valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schema } = this.state;
        const { abastecimento } = this.state;
        let errors = {};

        // Valida campos gerais do schema
        const requiredFields = [
            'data',
            'codveiculo',
            'nrotanque',
            'horimetro_km',
            'qtdlitros',
            'precoporlitro',
            //'valor',
            'codcombustivel',
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, abastecimento[field], schema);
            if (error) {
                errors[field] = error;
            }
        });

        // Valida apenas o campo relacionado ao tipo de abastecimento
        if (abastecimento.tipoabastecimento == ATIPO_INTERNO) {
            const codbombaError = validateField('codbomba', abastecimento.codbomba, schema);
            if (codbombaError) {
                errors.codbomba = "Bomba interna obrigatória!";
            }
        }

        /* outras validações */
        if (this.state.isNewRecord) {
            if (this.state.configuracoes.ultimonrotanque >=
                abastecimento.nrotanque) {
                let tanque = {
                    field: {
                        presence: { allowEmpty: false, message: 'Numeração do tanque inferior ou igual a última numeração' },
                    }
                }
                errors.tanque = tanque;
                this.handleOpenAlert(errors.tanque.field.presence.message);
                return errors;
            }
        }


        // Atualiza os erros no estado
        this.setState({ errors });

        // Se houver erros, exibe alerta e retorna os erros
        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
        }

        return errors;
    }

    /* insere novo abastecimento */
    insereAbastecimento = async () => {
        const { abastecimento } = this.state;
        abastecimento.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
        try {
            const response = await api.post(`/abastecimento`, abastecimento);
            if (response.status === 200) {
                this.props.history.push('/front/abastecimento');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    render() {
        const { abastecimento } = this.state;
        const { veiculos } = this.state;
        const { classes } = this.state;
        const { combustiveis } = this.state;
        const { errors } = this.state;
        const { bombas } = this.state;
        const { configuracoes } = this.state;

        return (
            <div>
                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                    >
                        Abastecimento {abastecimento.codabastecimento}
                    </Typography>

                    <br />


                    <Box width="100%">

                        <FormControl
                            className={classes.textField}
                            style={{ marginRight: "1rem", width: "30%", maxWidth: "30%" }}
                            variant="filled"
                            disabled={this.state.isView}

                        >
                            <InputLabel
                                htmlFor="outlined-age-native-simple"
                                shrink={true} // Isso evita a sobreposição
                                style={{ padding: '0 4px' }} // Estilo adicional para melhor visualização
                            >
                                Tipo Abastecimento
                            </InputLabel>

                            <Select
                                inputProps={{
                                    id: 'outlined-age-native-simple',
                                    name: 'tipoabastecimento'
                                }}
                                label="Tipo Abastecimento"
                                native
                                onChange={this.OnChange}
                                value={abastecimento.tipoabastecimento}
                            >
                                <option
                                    key={ATIPO_EXTERNO}
                                    value={ATIPO_EXTERNO}
                                >
                                    {"Externo"}</option>

                                <option
                                    key={ATIPO_INTERNO}
                                    value={ATIPO_INTERNO}
                                >
                                    {"Interno"}</option>
                            </Select>
                        </FormControl>

                        <TextField
                            className={classes.textField}
                            InputLabelProps={{ shrink: true, required: false }}
                            inputProps={{ maxLength: 30 }} // tamanho máximo permitido
                            label="Data"
                            name="data"
                            onChange={this.OnChange}
                            type="date"
                            error={!!errors.data}
                            value={abastecimento.data}
                            variant="outlined"
                            disabled={this.state.isView}
                            helperText={errors.data || ''}
                        />
                        <FormControl
                            //fullWidth
                            variant="outlined"
                            disabled={this.state.isView}
                            className={classes.textField}
                            style={{
                                position: 'absolute',
                                marginLeft: '0.5rem', // <-- Aqui você define a distância lateral
                                width: '30%',
                                visibility: (abastecimento.tipoabastecimento == ATIPO_INTERNO) ? 'visible' : 'hidden',
                                opacity: (abastecimento.tipoabastecimento == ATIPO_INTERNO) ? 1 : 0,
                                transition: 'opacity 0.3s ease-in-out'
                                //display: (abastecimento.tipoabastecimento == ATIPO_INTERNO) ? '' : 'none' }}
                            }}
                        >
                            <ComboPadrao
                                name={'codbomba'}
                                label={'Bomba Interna'}
                                value={abastecimento.codbomba}
                                onChange={this.OnChange}
                                fieldId={'codbomba'}
                                listItems={bombas}
                                fieldDescription={'descbomba'}
                                helperText={errors.codbomba || ''}
                            />
                        </FormControl>


                    </Box>

                    <br />

                    <Box width="100%">
                        <FormControl
                            style={{ marginRight: "0.5rem", width: '50%' }}
                            variant="outlined"
                            disabled={this.state.isView}
                            className={classes.textField}
                        >
                            <ComboPadrao
                                name={'codveiculo'}
                                label={'Veículo'}
                                value={abastecimento.codveiculo}
                                onChange={this.OnChange}
                                fieldId={'codveiculo'}
                                helperText={errors.codveiculo || ''}
                                listItems={veiculos}
                                fieldDescription={'descveiculo'}
                            />
                        </FormControl>

                        <FormControl
                            style={{ marginRight: "0.5rem", width: '45%' }}
                            variant="outlined"
                            disabled={this.state.isView}
                            className={classes.textField}
                        >
                            <ComboPadrao
                                name={'codcombustivel'}
                                label={'Combustível'}
                                value={abastecimento.codcombustivel}
                                onChange={this.OnChange}
                                fieldId={'codcombustivel'}
                                listItems={combustiveis}
                                fieldDescription={'desccombustivel'}
                                helperText={errors.codcombustivel || ''}
                            />
                        </FormControl>
                    </Box>
                    <br />

                    <Box style={{ position: 'relative', width: '100%' }}>

                        <TextField
                            className={this.state.useStyles.textField}
                            label="Nro. Tanque"
                            style={{ marginRight: "0.5rem", width: '45%' }}
                            name="nrotanque"
                            value={abastecimento.nrotanque || ''}
                            variant="outlined"
                            onChange={this.OnChange}
                            error={!!errors.nrotanque}
                            disabled={this.state.isView}
                            type="number"
                            helperText={errors.nrotanque || ''}
                        />
                        <TextField
                            className={this.state.useStyles.textField}
                            label="Hodômetro / Contador"
                            style={{ marginRight: "0.5rem", width: '45%' }}
                            name="horimetro_km"
                            value={abastecimento.horimetro_km || ''}
                            variant="outlined"
                            onChange={this.OnChange}
                            error={!!errors.horimetro_km}
                            disabled={this.state.isView}
                            type="number"
                            helperText={errors.horimetro_km || ''}
                        />

                    </Box>

                    <Box style={{ position: 'relative', width: '100%' }}>
                        <FormControl
                            fullWidth
                            variant="outlined"
                            disabled={this.state.isView}
                            className={classes.textField}
                            style={{
                                position: 'absolute',
                                width: '100%',
                                visibility: (abastecimento.tipoabastecimento == ATIPO_EXTERNO) ? 'visible' : 'hidden',
                                opacity: (abastecimento.tipoabastecimento == ATIPO_EXTERNO) ? 1 : 0,
                                transition: 'opacity 0.3s ease-in-out'
                            }}
                        >
                        </FormControl>
                    </Box>

                    <br />

                    <FormGroup row>
                        <TextField
                            className={this.state.useStyles.textField}
                            inputProps={{ maxLength: 20 }}
                            label="Qtd. Litros"
                            style={{ marginRight: "0.5rem", width: '20%' }}
                            name="qtdlitros"
                            value={abastecimento.qtdlitros || ''}
                            variant="outlined"
                            onChange={this.OnChange}
                            error={!!errors.qtdlitros}
                            disabled={this.state.isView}
                            type="number"
                            helperText={errors.qtdlitros || ''}
                        />

                        <CurrencyTextField
                            className={this.state.useStyles.textField}
                            label="Valor Litro"
                            style={{ marginRight: "0.5rem", width: '20%' }}
                            name="precoporlitro"
                            id="precoporlitro"
                            value={abastecimento.precoporlitro || ''}
                            variant="outlined"
                            currencySymbol=""
                            outputFormat="number"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            onChange={this.OnChange}
                            disabled={this.state.isView}
                            minimumValue="0"
                        />

                        <CurrencyTextField
                            className={this.state.useStyles.textField}
                            label="Valor Total"
                            style={{ marginRight: "0.5rem", width: '20%' }}
                            name="valor"
                            id="valor"
                            value={abastecimento.valor || ''}
                            variant="outlined"
                            currencySymbol=""
                            outputFormat="number"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            error={!!errors.valor}
                            onChange={this.OnChange}
                            disabled={this.state.isView}
                            minimumValue="0"
                            helperText={errors.valor || ''}
                        />
                    </FormGroup>

                    <br />

                    <Box width="100%">


                        <Typography
                            color="textSecondary"
                            component="p"
                            variant="body2"

                        >Observação Geral
                        </Typography>
                        <FormGroup >
                            <textarea
                                id="obs"
                                name="obs"
                                onChange={this.OnChange}
                                className={classes.textarea}
                                value={abastecimento.obs || ''}
                                disabled={this.state.isView}
                            />

                        </FormGroup>

                        {configuracoes && (
                            <Typography variant="body1" style={{ color: 'blue', marginTop: 4 }}>
                                Última numeração tanque: {configuracoes.ultimonrotanque}
                            </Typography>
                        )}

                    </Box>

                    <br />
                    <br />

                    <Button
                        name="salvar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickSave}
                        style={{ marginTop: '10px' }}
                        disabled={this.state.isView}
                    >
                        Salvar
                    </Button>

                    <Button
                        name="cancelar"
                        variant="contained"
                        onClick={this.onClickCancel}
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                        color="secondary"
                    >
                        Cancelar
                    </Button>
                </CardContent>

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />
            </div>
        );
    }
}

AbastecimentoForm.propTypes =
{
    classes: PropTypes.object.isRequired
};

export default AbastecimentoForm;


